import React from 'react'
import { BrowserRouter, Route, Routes, useNavigate } from 'react-router-dom'
import { AuthGuard, Login } from './components'
import { useRoutes } from './routes'
import ScrollToTop from './ScrollToTop'
import ErrorBoundary from 'ErrorBoundary'
import { useAppContext } from 'hooks/useAppContext'

const RoleGuard = ({ roles, element }) => {
  const navigate = useNavigate()
  const { currentUser } = useAppContext()

  if (roles.includes(currentUser?.role)) {
    return element
  } else {
    navigate('/dashboard')
  }
}

const App = () => {
  const routes = useRoutes()

  return (
    <div id="container">
      <ErrorBoundary>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/login" element={<Login />} exact />
            <Route element={<AuthGuard />}>
              {routes.map(({ roles, element, ...rest }) => {
                return <Route key={rest.path} {...rest} element={<RoleGuard roles={roles} element={element} />} />
              })}
            </Route>
          </Routes>
        </BrowserRouter>
      </ErrorBoundary>
    </div>
  )
}

export default App
